// Dữ liệu mẫu + logic thuần của Mint-AIRead (O-03). Chép từ code board: RQF / VSF / DOC. Kết quả đọc giả lập.
export type Target = 'rq' | 'vessel';
export type Kind = 'cp' | 'lock' | 'tay';
export type FieldDef = readonly [key: string, sec: string, label: string, read: string, form: string, conf: number, page: number, kind: Kind];
export type St = 'khop' | 'lech' | 'trong' | 'lock' | 'tay';
export type Seg = { x: string; b?: boolean; big?: boolean; k?: string };

export const LOW = 80;

export const RQF: readonly FieldDef[] = [
  ['bkno', 'bk', 'Booking No', 'YMJAM490367056', '', 98, 1, 'cp'],
  ['car', 'bk', 'Hãng tàu', 'YML', 'YML', 99, 1, 'lock'],
  ['cus', 'bk', 'Khách', 'ARRIVE', 'ARRIVE', 93, 1, 'lock'],
  ['bkdate', 'bk', 'Ngày booking', '21/Oct/2026', '', 92, 1, 'cp'],
  ['vsl', 'vs', 'Vessel', 'YM CERTAINTY', '', 96, 1, 'cp'],
  ['voy', 'vs', 'Voyage', '089N', '', 95, 1, 'cp'],
  ['pol', 'vs', 'POL', 'VNSGN', 'VNSGN', 97, 1, 'cp'],
  ['tml', 'vs', 'Terminal hạ', 'CAT LAI', 'CAT LAI', 90, 1, 'cp'],
  ['pod', 'vs', 'POD', 'KRKAN', 'KRKAN', 97, 1, 'cp'],
  ['fnd', 'vs', 'Nơi giao cuối', 'KWANGYANG', '', 74, 1, 'cp'],
  ['etd', 'vs', 'ETD', '18/Nov/2026 06:00', '17/Nov/2026 22:00', 90, 1, 'cp'],
  ['eta', 'vs', 'ETA POD', '29/Nov/2026 08:00', '', 88, 1, 'cp'],
  ['si', 'cut', 'SI cut-off', '15/Nov/2026 12:00', '', 86, 2, 'cp'],
  ['cy', 'cut', 'CY cut-off', '16/Nov/2026 17:00', '', 91, 2, 'cp'],
  ['vgm', 'cut', 'VGM cut-off', '15/Nov/2026 17:00', '', 68, 2, 'cp'],
  ['pick', 'cut', 'Lấy rỗng từ', '12/Nov/2026', '', 77, 2, 'cp'],
  ['cont', 'cg', 'Số lượng cont', '15x40HC', '15x40HC', 99, 1, 'cp'],
  ['cmd', 'cg', 'Hàng hoá', 'FURNITURE PARTS', '', 83, 1, 'cp'],
  ['gw', 'cg', 'Trọng lượng dự kiến', '18.420 kg', '', 64, 2, 'cp'],
  ['depot', 'cg', 'Depot rỗng', 'PHUOC LONG ICD 3', '', 79, 2, 'cp'],
  ['note', 'cg', 'Ghi chú nội bộ', '', '', 0, 0, 'tay'],
];

export const VSF: readonly FieldDef[] = [
  ['vsl', 'id', 'Vessel', 'YM CERTAINTY', 'YM CERTAINTY', 99, 1, 'lock'],
  ['voy', 'id', 'Voyage', '089N', '089N', 99, 1, 'lock'],
  ['car', 'id', 'Hãng tàu', 'YML', 'YML', 99, 1, 'lock'],
  ['svc', 'id', 'Service', 'PS3', 'PS3', 92, 1, 'cp'],
  ['tml', 'id', 'Loading terminal', 'CAT LAI', 'CAT LAI', 90, 1, 'cp'],
  ['pol', 'id', 'POL', 'VNSGN', 'VNSGN', 97, 1, 'cp'],
  ['etd', 'mk', 'ETD', '19/Nov/2026 02:00', '18/Nov/2026 06:00', 94, 1, 'cp'],
  ['eta', 'mk', 'ETA POD', '30/Nov/2026 08:00', '29/Nov/2026 08:00', 88, 1, 'cp'],
  ['si', 'mk', 'SI cut-off', '16/Nov/2026 12:00', '15/Nov/2026 12:00', 90, 1, 'cp'],
  ['cy', 'mk', 'CY cut-off', '17/Nov/2026 17:00', '16/Nov/2026 17:00', 92, 1, 'cp'],
  ['icd', 'mk', 'ICD cut-off', '', '15/Nov/2026 17:00', 0, 0, 'tay'],
  ['vgm', 'mk', 'VGM cut-off', '16/Nov/2026 17:00', '15/Nov/2026 17:00', 71, 1, 'cp'],
  ['ntype', 'nt', 'Loại notice', 'Delay', '', 85, 1, 'cp'],
  ['pwc', 'nt', 'PWC template', '', 'YML - CLI', 0, 0, 'tay'],
  ['remark', 'nt', 'Remark', 'Berth congestion at Cat Lai', '', 76, 1, 'cp'],
];

export const SECS: Record<Target, readonly (readonly [string, string])[]> = {
  rq: [['bk', 'Booking'], ['vs', 'Tàu & cảng'], ['cut', 'Cut-off'], ['cg', 'Hàng & cont']],
  vessel: [['id', 'Chuyến'], ['mk', 'Mốc giờ hãng'], ['nt', 'Notice']],
};

export const FILES: Record<Target, readonly (readonly [ext: string, name: string, kind: string, pages: number])[]> = {
  rq: [['PDF', 'BKG_CFM_YMJAM490367056.pdf', 'Đính kèm', 2], ['MAIL', 'YML Booking Confirmation YMJAM490367056', 'Thân thư', 1], ['XLS', 'Booking_Request_ARRIVE_2610.xlsx', 'Tệp khác', 1]],
  vessel: [['PDF', 'YML_Schedule_Notice_YMCERTAINTY_089N.pdf', 'Đính kèm', 1], ['MAIL', 'Revised schedule YM CERTAINTY 089N', 'Thân thư', 1]],
};

const R = (k: string) => ({ k });
export const DOC: Record<Target, Record<number, Seg[][]>> = {
  rq: {
    1: [[{ x: 'YANG MING MARINE TRANSPORT CORP.', b: true }], [{ x: 'BOOKING CONFIRMATION', b: true, big: true }], [{ x: 'Booking No.: ' }, { x: 'YMJAM490367056', ...R('bkno') }, { x: '   Date: ' }, { x: '21-OCT-2026', ...R('bkdate') }], [{ x: 'Carrier: ' }, { x: 'YML', ...R('car') }, { x: '   Booking party: ' }, { x: 'ARRIVE CO., LTD', ...R('cus') }],
      [{ x: '' }], [{ x: 'Vessel / Voyage: ' }, { x: 'YM CERTAINTY', ...R('vsl') }, { x: ' / ' }, { x: '089N', ...R('voy') }], [{ x: 'Port of Loading: ' }, { x: 'HO CHI MINH (VNSGN)', ...R('pol') }, { x: '  Terminal: ' }, { x: 'CAT LAI', ...R('tml') }],
      [{ x: 'Port of Discharge: ' }, { x: 'KWANGYANG (KRKAN)', ...R('pod') }], [{ x: 'Final destination: ' }, { x: 'KWANGYANG, KR', ...R('fnd') }], [{ x: 'ETD: ' }, { x: '18-NOV-2026 06:00', ...R('etd') }, { x: '   ETA: ' }, { x: '29-NOV-2026 08:00', ...R('eta') }],
      [{ x: '' }], [{ x: 'Equipment: ' }, { x: "15 x 40' HC", ...R('cont') }], [{ x: 'Commodity: ' }, { x: 'FURNITURE PARTS (KD)', ...R('cmd') }], [{ x: '' }], [{ x: 'Subject to terms and conditions of YML booking.' }]],
    2: [[{ x: 'CUT-OFF & EMPTY RELEASE', b: true }], [{ x: 'SI closing: ' }, { x: '15-NOV-2026 12:00', ...R('si') }], [{ x: 'CY closing: ' }, { x: '16-NOV-2026 17:00', ...R('cy') }], [{ x: 'VGM closing: ' }, { x: '15-NOV 17:00 (local)', ...R('vgm') }],
      [{ x: '' }], [{ x: 'Empty pick-up from: ' }, { x: '12-NOV', ...R('pick') }, { x: '  at ' }, { x: 'PHUOC LONG ICD 3', ...R('depot') }], [{ x: 'Est. gross weight: ' }, { x: '18,420 KGS', ...R('gw') }], [{ x: '' }], [{ x: 'Late gate-in subject to carrier approval.' }]],
  },
  vessel: {
    1: [[{ x: 'YANG MING · SCHEDULE NOTICE', b: true, big: true }], [{ x: 'Vessel: ' }, { x: 'YM CERTAINTY', ...R('vsl') }, { x: '  Voy: ' }, { x: '089N', ...R('voy') }, { x: '  Carrier: ' }, { x: 'YML', ...R('car') }], [{ x: 'Service: ' }, { x: 'PS3', ...R('svc') }, { x: '  Terminal: ' }, { x: 'CAT LAI', ...R('tml') }, { x: '  POL: ' }, { x: 'VNSGN', ...R('pol') }],
      [{ x: 'Notice type: ' }, { x: 'DELAY', ...R('ntype') }], [{ x: '' }], [{ x: 'Revised ETD: ' }, { x: '19-NOV-2026 02:00', ...R('etd') }], [{ x: 'Revised ETA Kwangyang: ' }, { x: '30-NOV 08:00', ...R('eta') }], [{ x: 'SI closing: ' }, { x: '16-NOV-2026 12:00', ...R('si') }],
      [{ x: 'CY closing: ' }, { x: '17-NOV-2026 17:00', ...R('cy') }], [{ x: 'VGM closing: ' }, { x: '16-NOV 17:00', ...R('vgm') }], [{ x: '' }], [{ x: 'Reason: ' }, { x: 'Berth congestion at Cat Lai', ...R('remark') }]],
  },
};

export const MAIL: Record<Target, Seg[][]> = {
  rq: [[{ x: 'From: booking@yml.com.vn · 21/Oct/2026 10:42' }], [{ x: 'Subject: YML Booking Confirmation YMJAM490367056' }], [{ x: '' }], [{ x: 'Dear HANA team, please find attached booking confirmation for ' }, { x: '15x40HC', ...R('cont') }, { x: ' VNSGN – KRKAN on ' }, { x: 'YM CERTAINTY', ...R('vsl') }, { x: ' ' }, { x: '089N', ...R('voy') }, { x: '.' }], [{ x: 'Best regards, YML Booking' }]],
  vessel: [[{ x: 'From: sc•••@yml.com.vn · 22/Oct/2026 09:15' }], [{ x: 'Subject: Revised schedule YM CERTAINTY 089N' }], [{ x: '' }], [{ x: 'Please note ' }, { x: 'YM CERTAINTY', ...R('vsl') }, { x: ' ' }, { x: '089N', ...R('voy') }, { x: ' ETD revised to ' }, { x: '19-NOV 02:00', ...R('etd') }, { x: ' due to ' }, { x: 'berth condition', ...R('remark') }, { x: '.' }]],
};

export const IMP: readonly (readonly [job: string, cus: string, ty: string, cn: string, s: string])[] = [
  ['SE260639460', 'ARRIVE', 'OB', '15x40HC', 'BK Confirmed'],
  ['SE260639480', 'MCSEA', 'OB', '2x40RH', 'BK Standby'],
  ['SE260639410', 'HAILONGFISH', 'OB', '1x40RH', 'BK Confirmed'],
  ['SE260639390', 'SAVITA', 'OB', '4x40HC', 'BL Hold'],
];

export const norm = (x: string) => x.trim().toUpperCase();

export interface Edits {
  fv: Record<string, string>; // giá trị form đã sửa / chép
  cp: Record<string, string>; // giá trị trước lần chép (để hoàn tác)
  okm: Record<string, boolean>;
  ed: Record<string, boolean>;
}

export interface RowView { def: FieldDef; st: St; look: boolean; cur: string; ai: boolean; copied: boolean; ok: boolean }

export function buildRows(defs: readonly FieldDef[], e: Edits, ns: (k: string) => string): RowView[] {
  return defs.map((def) => {
    const [k, , , read, form, conf, , kind] = def;
    const key = ns(k);
    const ai = kind === 'cp' && !!read && !form && e.fv[key] === undefined;
    const cur = e.fv[key] !== undefined ? e.fv[key]! : ai ? read : form;
    let st: St;
    if (kind === 'tay' || !read) st = 'tay';
    else if (norm(cur) === norm(read)) st = 'khop';
    else if (kind === 'lock') st = 'lock';
    else st = cur ? 'lech' : 'trong';
    const look = kind !== 'tay' && !!read && conf < LOW && !e.okm[key] && !e.ed[key];
    return { def, st, look, cur, ai, copied: key in e.cp || ai, ok: !!e.okm[key] || !!e.ed[key] };
  });
}

export const needLook = (r: RowView) => r.look || r.st === 'lech';
